module.exports = __webpack_public_path__ + "img/join-icon.d122de52.png";